import {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import DomUtils from '../../../../v2/utils/DomUtils';
import * as DeviceSelectors from '../../../../v2/selectors/DeviceSelectors';

export function Entrust(props) {
  const entrustElement = useRef(null);
  
  const insertEntrustCode = () => {
    const {isMobile, domain} = props;
    const options = {domain, style: (isMobile ? '16' : '9'), container: 'entrust-net-seal'};
    DomUtils.addScript('https://seal.entrust.net/sealv2.js')
      .then(() => {
        try {
          const element = entrustElement.current;
          if (element && element.firstChild.id !== 'entrust-net-seal') {
            element.removeChild(element.firstChild);
          }
          window.goEntrust(options);
        } catch (e) {
        }
      });
  };
  
  useEffect(() => {
    insertEntrustCode();
  }, []);
  
  useEffect(() => {
    insertEntrustCode();
  }, [props.isMobile]);
  
  return (
    <div className="Entrust" ref={entrustElement}>
      <div id="entrust-net-seal">
        <a href="https://www.entrust.com/ssl-certificates/" className="Entrust__text">SSL Certificate</a>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  isMobile: DeviceSelectors.isMobile(state),
  domain: state.start.settings.security_certificate && state.start.settings.security_certificate.domain,
});

Entrust.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  domain: PropTypes.string.isRequired,
};

export default connect(
  mapStateToProps,
)(Entrust);
